import {
  FEATURE_DEFAULTS,
  FeatureVisibility,
  IFeature,
} from '@principle-theorem/feature-flags';

export const SETUP_WIZARD_FEATURE: IFeature = {
  ...FEATURE_DEFAULTS,
  label: 'setup-wizard',
  visibility: FeatureVisibility.Stable,
  permissions: [],
};
